import axios from 'axios';

const LoginCookieAuth = async (key) => {
    const headers = {"Authorization": "BEARER authToken=" + key} 
    try { 
      const authresponse = await axios.get('https://infinity.skyspark.nl/api/sys/uiPoll', {headers});
      if(authresponse.status === 200) return true
      else return false
    } catch {
      return false;
    }
};

export default LoginCookieAuth;
